export const HOMEPAGE_EXTERNAL_LINKS = {
  requestFeature: 'https://github.com/AAInternal/runway/issues/new?template=user-story.yml&labels=customer+request',
  slackChannel: 'https://americanairlines.slack.com/archives/C0112F1JKNG',
  emuMigrationDocs: 'https://developer.aa.com/docs/default/component/devops-tech-enablement/emu/',
} as const;
